module.exports = __webpack_public_path__ + "img/icon_pharmacy_white.d7543e9a.svg";